const LAY_DANH_SACH_VAN_BAN_THANH_CONG = (state, danhSachVanBan) => {
  state.danhSachVanBan = danhSachVanBan;
};

const SET_DANH_SACH_DON_VI_NGOAI = (state, danhSachDonViNgoai) => {
  state.danhSachDonViNgoai = danhSachDonViNgoai;
};

const TAO_VAN_BAN_THANH_CONG = (state, vanBan) => {
  state.danhSachVanBan.push(
    Object.assign({}, vanBan, { id: state.vanBanId + 1 })
  );
};

const CAP_NHAT_VAN_BAN_THANH_CONG = (state, vanBan) => {
  const editItemIndex = state.danhSachVanBan.findIndex(
    (obj) => obj.id === parseInt(vanBan.id)
  );
  state.danhSachVanBan[editItemIndex] = vanBan;
};

const XOA_VAN_BAN_THANH_CONG = (state, vanBan) => {
  state.danhSachVanBan.splice(state.danhSachVanBan.indexOf(vanBan), 1);
};

const TANG_ID_VAN_BAN = (state) => {
  state.vanBanId++;
};

const LAY_CHI_TIET_VAN_BAN_THANH_CONG = (state, vanBanId) => {
  const editItemIndex = state.danhSachVanBan.findIndex(
    (obj) => obj.id === parseInt(vanBanId)
  );

  state.vanBanDangCapNhat = state.danhSachVanBan[editItemIndex];
};

export default {
  LAY_DANH_SACH_VAN_BAN_THANH_CONG,
  TAO_VAN_BAN_THANH_CONG,
  CAP_NHAT_VAN_BAN_THANH_CONG,
  XOA_VAN_BAN_THANH_CONG,
  TANG_ID_VAN_BAN,
  LAY_CHI_TIET_VAN_BAN_THANH_CONG,
  SET_DANH_SACH_DON_VI_NGOAI,
};
